import { render, staticRenderFns } from "./SettingsClinicalTeamForm.vue?vue&type=template&id=46bd0e18"
import script from "./SettingsClinicalTeamForm.vue?vue&type=script&lang=js"
export * from "./SettingsClinicalTeamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports